
export const environment = {
  production: true
};


export { CMSProdModule as CMSModule } from '../lib/ng2-sapmp/src/modules/cms/cms.module.prod';
export { LoginProdModule as LoginModule } from '../lib/ng2-sapmp/src/modules/login/login.module.prod';


